import qs from 'querystring'

import _ from 'underscore'

import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import STATUS_CODE from '../constant/status_code'

const url = COOKIECONSTANT.REQUEST_HOST
const emptyProductListData = {
  page: {
    total: 0,
  },
  list: [],
}


const getBannerByHotSaleList = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if (!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    Api.get(url + `${query}`, {
        headers: {
          'X-Host': 'mall.cfg.common-banner',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if (data.status != 0) {
          return reject(data)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const getProductByHotSaleList = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if (!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    Api.get(url + query, {
        headers: {
          'X-host': 'mall.product.hot-sale-list', //real
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
        },
      })
      .then((data) => {
        if (data.status === STATUS_CODE.EMPTY_LIST) {
          return resolve(emptyProductListData)
        }
        if (data.status !== 0) {
          return reject(data.msg)
        }
        return resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}

export default {
  getBannerByHotSaleList,
  getProductByHotSaleList,
}
